import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import JumboDemoCard from "@jumbo/components/JumboDemoCard/JumboDemoCard";
import { AffilateReportApi } from "backendServices/ApiCalls";
import { Grid, TableCell } from "@mui/material";
import SweetAlert from "app/pages/components/mui/Alerts/SweetAlert";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";

const Affiliatereport = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [affilateReport, setAffilateReport] = useState([]);

  const [alertData, setalertData] = useState({
    show: false,
    message: "",
    variant: "",
  });

  const AffilateReport = () => {
    AffilateReportApi(
      (response) => {
        const processedData = response?.data?.data?.enteries.map(
          (row, index) => ({
            ...row,
            index: index + 1,
          })
        );
        setAffilateReport(processedData);
      },
      (error) => {}
    );
  };

  useEffect(() => {
    AffilateReport();
  }, []);
  const rowsWithIndex = affilateReport?.map((row, index) => ({
    ...row,
    id: index + 1,
  }));

  const columns = [
    {
      field: "index",
      headerName: "#",
      width: 80,
      // valueGetter: (params) => params.row.id,
    },
    {
      field: "username",
      headerName: "User Name",
      width: 200,
      editable: true,
      groupable: false,
    },
    {
      field: "firstname",
      headerName: "First Name",
      width: 200,
      editable: true,
      groupable: false,
    },
    {
      field: "lastname",
      headerName: "Last Name",
      width: 200,
      editable: true,
      groupable: false,
    },
    {
      field: "email",
      headerName: "Email",
      width: 200,
      editable: true,
      groupable: false,
    },

    {
      field: "amount",
      headerName: "Amount",
      width: 100,
      editable: true,
      renderCell: (params) => {
        const { value } = params;
        return <TableCell>€{value}</TableCell>;
      },
    },

    {
      field: "activatedAt",
      headerName: "ActivatedAt",
      width: 300,
      editable: true,
      groupable: false,
      renderCell: (params) => {
        const { value } = params;
        const date = new Date(value * 1000); // Convert UNIX timestamp to milliseconds
        const options = {
          year: "numeric",
          month: "long",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        };
        return (
          <TableCell>
            {new Intl.DateTimeFormat("default", options).format(date)}
          </TableCell>
        );
      },
    },
    {
      field: "nextBillingAt",
      headerName: "Next BillingAt",
      width: 300,
      editable: true,
      groupable: false,
      renderCell: (params) => {
        const { value } = params;
        const date = new Date(value * 1000); // Convert UNIX timestamp to milliseconds
        const options = {
          year: "numeric",
          month: "long",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        };
        return (
          <TableCell>
            {new Intl.DateTimeFormat("default", options).format(date)}
          </TableCell>
        );
      },
    },

    {
      field: "sub_type",
      headerName: "Priod",
      width: 200,
    },
  ];

  const gridDesign = {
    "& .MuiDataGrid-toolbarContainer": {
      "& .MuiButton-text": {
        fontSize: "13px !important",
      },
      "& .MuiBadge-badge": {
        backgroundColor: "#074682",
      },
      "& .MuiInput-root": {
        borderRadius: 2,
        paddingLeft: 2,
        overflow: "hidden",
      },
    },
  };

  return (
    <Grid
      container
      fullWidth
      sm={12}
      xs={12}
      p={2}
      alignItems="center"
      justifyContent="center"
    >
      <Grid item sm={12} xs={12}>
        <JumboDemoCard
          title={t("pages.title.affiliatereport")}
          wrapperSx={{ backgroundColor: "background.paper", pt: 0 }}
        >
          {alertData.show && (
            <SweetAlert alertData={alertData} setalertData={setalertData} />
          )}
          {/* {isLoading ? (
              <Div
              sx={{
                mt:"20%",
                ml:"45%",
                mb: "20%"
              }}
            >
              <CircularProgress />
            </Div>
          ):( */}

          <Box sx={{ height: 500, width: 1 }}>
            <DataGrid
              initialState={{
                pagination: { paginationModel: { pageSize: 6 } },
              }}
              rows={affilateReport}
              getRowId={(row) => row.id}
              columns={columns}
              slots={{ toolbar: GridToolbar }}
              // slots={{
              //     toolbar: (props) => (
              //         <GridToolbar
              //             {...props}
              //             sx={{
              //                 backgroundColor: theme.palette.mode === 'dark' ? '#424242' : '#fff',
              //                 '& .MuiIconButton-root': {
              //                     color: theme.palette.mode === 'dark' ? '#fff' : '#000',
              //                 },
              //             }}
              //         />
              //     ),
              // }}
              sx={gridDesign}
              pageSizeOptions={[6, 12, 18, 24, 30]}
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
            />
          </Box>
          {/* )} */}
        </JumboDemoCard>
      </Grid>
    </Grid>
  );
};

export default Affiliatereport;
